import React, { memo } from 'react';

import { DownOutlined as ChevronDown, UpOutlined as ChevronUp } from '@ant-design/icons';

import { Mask } from 'v2/components/Shared/ValuesVisibility';
import { numberToBRL } from 'v2/helpers/money';
import { EFinancialStatementTabs } from 'v2/interfaces/financial';
import type { SomeFinancialStatementTabs, IFinancialEntry } from 'v2/interfaces/financial';

import ContentInnerTable from '../ContentInnerTable';

interface IProps {
  selected: boolean;
  data: IFinancialEntry;
  index: number;
  handleSelect: (...args: any[]) => any;
  balanceLabel: string;
  showBlockedDetails?: boolean;
  currentTab?: SomeFinancialStatementTabs;
}

function ContentItem({ selected, data, index, handleSelect, balanceLabel, showBlockedDetails, currentTab }: IProps) {
  const formatDate = (dateRaw: string) => new Intl.DateTimeFormat('pt-BR').format(new Date(`${dateRaw}T00:00:00`));

  return (
    <div>
      <div className='p-0!'>
        <div
          className='text-grey-600 [&_small]:text-grey-400 flex cursor-pointer items-center px-2 py-3 text-sm font-semibold transition-all duration-300 ease-in-out hover:bg-black/[0.01] [&_small]:text-sm! [&_small]:font-normal! [&>div:first-of-type]:flex [&>div:first-of-type]:grow max-sm:[&>div:first-of-type]:flex-col [&>div:first-of-type>div]:px-2 max-sm:[&>div:first-of-type>div]:px-0 max-sm:[&>div:first-of-type>div]:py-1'
          onClick={() => handleSelect(index)}
        >
          <div>
            <div>
              {showBlockedDetails && 'Bloqueio em '}
              {formatDate(data.transaction_date)}
            </div>
            <div className='grow'>
              <small>{`${data.items} registros`}</small>
            </div>
            {currentTab === EFinancialStatementTabs.STATEMENT && (
              <>
                <div>
                  <small className='pr-4'>Créditos</small>
                  <Mask>{typeof data?.positive === 'number' ? numberToBRL(data?.positive) : 'R$ -'}</Mask>
                </div>
                <div>
                  <small className='pr-4'>Débitos</small>
                  <Mask>{typeof data?.negative === 'number' ? numberToBRL(data?.negative) : 'R$ -'}</Mask>
                </div>
              </>
            )}
            <div>
              <small className='pr-4'>{balanceLabel}</small>
              <Mask>{numberToBRL(data.balance)}</Mask>
            </div>
          </div>
          <div>{!!selected && !showBlockedDetails ? <ChevronUp /> : <ChevronDown />}</div>
        </div>
        {selected && (
          <div className='px-2 pb-3 max-sm:p-0'>
            <ContentInnerTable transactionDate={data.transaction_date} showBlockedDetails={showBlockedDetails} />
          </div>
        )}
      </div>
    </div>
  );
}

export default memo(ContentItem);
